import { API } from './API';

const DEFAULT_OPTIONS = {
  baseUrl: 'graphql',
};

export class ReportAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  get({
    orgId,
  }) {
    const query = `
      query Report($orgId: ID!) {
        listReports(orgId: $orgId) {
          id
          created
          created_by
          criteria
          name
          org
          schedule
          tags {
            id
            name
          }
          type
        }
      }
    `;
    const data = {
      orgId,
    };
    return super.get({ query, data }).then(({ listReports }) => ({ data: listReports }));
  }

  findById(orgId, id) {
    const query = `
      query Report($id: ID!) {
        getReport(id: $id) {
          id
          created
          created_by
          criteria
          name
          org
          schedule
          tags {
            id
            name
          }
          type
        }
      }
    `;
    const data = {
      id,
    };
    return super.get({ query, data }).then(({ getReport }) => ({ data: getReport }));
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/ReportAPI.js